/* eslint-disable max-lines */

import { color } from 'styles/colors'
import {
  ACCESSORIES_PLOT_BAND_Y_AXIS_NAME,
  AIRFLOW_STEPS_Y_AXIS_NAME,
  ID_PLOT_BAND_Y_AXIS_NAME,
  OD_PLOT_BAND_Y_AXIS_NAME,
  TEMP_HUMIDITY_Y_AXIS_NAME
} from 'pages/Device/ThermostatRthPanel/Chart/chartOptions'

const getStageParameter = (name, color, axis, parameterName, min = 0, max = 100) => {
  return {
    name,
    seriesName: name,
    yaxis: [...axis],
    parameterName,
    fillcolor: color,
    line: {
      color,
      shape: 'hv'
    },
    fill: 'toself',
    min,
    max
  }
}

const outDoorUnit = [
  {
    name: 'outdoorLiquidPressureOccurrences',
    seriesName: 'liquidPressure',
    yaxis: AIRFLOW_STEPS_Y_AXIS_NAME,
    parameterName: 'pressure',
    line: {
      color: color('legendOdLiquidPressure'),
      shape: 'linear'
    }
  },
  {
    name: 'outdoorLiquidTempOccurrences',
    seriesName: 'odLiquidTemp',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendOdLiquidTemp')
    }
  },
  {
    name: 'outdoorSubcoolOccurrences',
    seriesName: 'odSubcool',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendOdSubCool')
    }
  },
  {
    name: 'outdoorSuctionPressureOccurrences',
    seriesName: 'odSuctionPressure',
    yaxis: AIRFLOW_STEPS_Y_AXIS_NAME,
    parameterName: 'pressure',
    line: {
      color: color('legendOdSuctionPressure')
    }
  },
  {
    name: 'outdoorSuctionTempOccurrences',
    seriesName: 'suctionTemperature',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendOdSuctionTemperature')
    }
  },
  {
    name: 'outdoorSuperheatOccurrences',
    seriesName: 'odSuperheat',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendOdSuperheat')
    }
  },
  {
    name: 'outdoorEevStepPositionOccurrences',
    seriesName: 'odEevStepPosition',
    yaxis: AIRFLOW_STEPS_Y_AXIS_NAME,
    parameterName: 'value',
    line: {
      color: color('legendOdEevStepColor'),
      shape: 'hv'
    }
  },
  {
    name: 'outdoorCoilTemperatureOccurrences',
    seriesName: 'odCoilTemp',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendOdCoilTemp')
    }
  },
  {
    name: 'outdoorTemps',
    seriesName: 'outdoorTemp',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: '#ffe300'
    }
  },
  {
    name: 'outdoorHumidity',
    seriesName: 'outdoorHumidity',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'humidity',
    line: {
      color: '#ffe300',
      dash: 'longdashdot'
    }
  }
]

const indoorUnit = [
  {
    name: 'indoorAirflowActualOccurrences',
    seriesName: 'actualAirflow',
    yaxis: AIRFLOW_STEPS_Y_AXIS_NAME,
    parameterName: 'airflow',
    line: {
      color: color('indoorUnitActualAirflow'),
      dash: 'dashdot',
      shape: 'hv'
    }
  },
  {
    name: 'indoorCoilTempOccurrences',
    seriesName: 'coilTemp',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendIdCoilTemp'),
      dash: 'dashdot'
    }
  },
  {
    name: 'indoorGasSuperheatOccurrences',
    seriesName: 'gasSuperheat',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendIdSuperHeat'),
      dash: 'longdashdot'
    },
    connectgaps: false
  },
  {
    name: 'indoorGasSuperheatTempOccurrences',
    seriesName: 'gasSuperheat',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendIdSuperHeat'),
      dash: 'longdashdot'
    },
    connectgaps: false
  },
  {
    name: 'indoorGasTempOccurrences',
    seriesName: 'gasTemp',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendGasTemp'),
      dash: 'longdashdot'
    }
  },
  {
    name: 'indoorEevStepPositionOccurrences',
    seriesName: 'idEevStep',
    yaxis: AIRFLOW_STEPS_Y_AXIS_NAME,
    parameterName: 'value',
    line: {
      color: color('legendIdEevStepColor'),
      shape: 'hv'
    }
  },
  {
    name: 'indoorReturnAirTempOccurrences',
    seriesName: 'idReturnAirTemp',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendIdReturnAirTempColor')
    }
  },
  {
    name: 'indoorSupplyAirTempOccurrences',
    seriesName: 'idSupplyAirTemp',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendIdSupplyAirTempColor')
    }
  }
]

export const TracesConfig = [
  ...indoorUnit,
  ...outDoorUnit
]

export const AccessoriesConfig = [
  getStageParameter('VENTILATOR', '#9A89FF', [ACCESSORIES_PLOT_BAND_Y_AXIS_NAME], 'capacity', 0, 50),
  getStageParameter('HUMIDIFIER', '#F3B879', [ACCESSORIES_PLOT_BAND_Y_AXIS_NAME], 'capacity', 50, 100),
  getStageParameter('DEHUMIDIFIER', '#F8EE08', [ACCESSORIES_PLOT_BAND_Y_AXIS_NAME], 'capacity', 50, 100)
]

export const StageTracesConfig = [
  getStageParameter('COMPRESSOR_COOLING', '#1F729D', [OD_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('COMPRESSOR_COOLING_STAGE_1', '#6BBEEA', [OD_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('COMPRESSOR_COOLING_STAGE_2', '#1F729D', [OD_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('COMPRESSOR_HEATING', '#BC1C10', [OD_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('COMPRESSOR_HEATING_STAGE_1', '#FC6C68', [OD_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('COMPRESSOR_HEATING_STAGE_2', '#BC1C10', [OD_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('DEFROST', '#FFA500', [OD_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('QUIET_MODE', '#D1EA13', [OD_PLOT_BAND_Y_AXIS_NAME], 'capacity', 0, 20),
  getStageParameter('SYSTEM_MODE_OFF', '#6B6B6B', [ID_PLOT_BAND_Y_AXIS_NAME, OD_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('INDOOR_HEATING', '#BC1C10', [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('INDOOR_HEATING_STAGE_1', '#FF9DA6', [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('INDOOR_HEATING_STAGE_2', '#FC6C68', [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('INDOOR_HEATING_STAGE_3', '#BC1C10', [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('ELECTRIC_HEATING_STAGE_1', '#FF9DA6', [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('ELECTRIC_HEATING_STAGE_2', '#FC6C68', [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('ELECTRIC_HEATING_STAGE_3', '#BC1C10', [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('GAS_HEATING_STAGE_1', '#FF9DA6', [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('GAS_HEATING_STAGE_2', '#FC6C68', [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('GAS_HEATING_STAGE_3', '#BC1C10', [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('HYDRONIC_HEATING_STAGE_1', '#FC6C68', [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('INDOOR_FAN_ONLY', '#89A982', [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('INTEGRATED_DEHUMIDIFICATION', '#00FF00', [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity', 80),
  ...AccessoriesConfig
]

export const ZoneTracesConfig = [
  {
    name: 'coolingSetpointOccurrences',
    seriesName: 'cooling',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      shape: 'hv',
      dash: 'dot',
      width: 1
    },
    fill: 'none'
  },
  {
    name: 'heatingSetpointOccurrences',
    seriesName: 'heating',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      dash: 'dash',
      shape: 'hv',
      width: 1
    },
    fill: 'none'
  },
  {
    name: 'tempOccurrences',
    seriesName: 'indoorTemp',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {}
  },
  {
    name: 'humidityOccurrences',
    seriesName: 'indoorHumidity',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'humidity',
    line: {
      dash: 'dashdot'
    }
  },
  {
    name: 'relievingOccurrences',
    seriesName: 'relieving',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    mode: 'markers',
    line: {
      dash: 'dashdot'
    }
  }
]

export const Alerts = {
  name: 'alarmOccurrences'
}
